import { createContext, useContext } from "react";
import { WORK_WITH_US_URL } from "../content/clients";

export const SiteContext = createContext({ casesBase: "", homePath: "/", applyUrl: WORK_WITH_US_URL, tracked: false });

export function useSite() {
  const site = useContext(SiteContext);
  const applyHref = (path) => {
    if (!site.tracked || !path) return site.applyUrl;
    const ref = site.homePath !== "/" && path.startsWith(site.homePath) ? path.slice(site.homePath.length) || "/" : path;
    return `${site.applyUrl}?ref=${encodeURIComponent(ref)}`;
  };
  return { ...site, applyHref };
}
